import { InjectionToken } from '@angular/core';

/**
 * @deprecated After this issue https://support.scalefast.ninja/issues/157639 we need to refactor the code to remove this token
 */
export const PAGE_DATA = new InjectionToken<any>('PAGE_DATA');
export const IS_BUILDER_EDITOR = new InjectionToken<boolean>('IS_BUILDER_EDITOR');
